import { IRunRequest } from '../entities/services';
import { ProjectHelper } from '@bimser/common';

export function RunEvent<TUserEventArgs>(
	projectName: string,
	formName: string,
	data: IRunRequest<TUserEventArgs>
) {
	return ProjectHelper.RunPromiseFormService({
		projectName: projectName,
		formName: formName,
		serviceName: 'Run',
		requestParameters: data
	});
}
